<script>
    export default {
        name: 'PasswordDialog',
        props: {
            value: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: ''
            },
            confirmOld: {
                type: Boolean,
                default: false
            },
            cancel: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                dialog: false,
                gfName: 'gfPwDialog',
                gfCallbacks: {
                    beforeValidation: formdata => {
                        // TODO check for valid pattern (not valid chars in keycloak) => §°$´`+€%ß
                        if (!formdata) return false // not valid
                        if (!formdata['vpw-new']) return false
                        return formdata['vpw-new'] === formdata['vpw-new-confirm']
                    },
                    onSubmitAction: formdata => {
                        // TODO only emit vpw-new-confirm?
                        this.$emit('submit', formdata)
                    },
                    onCancelAction: () => {this.close()}
                }
            }
        },

        computed: {
            gfConfig() {
                const actions = ['save']
                if (this.cancel) actions.push('cancel')

                return {
                    header: this.title,
                    stacked: true,
                    fillstyle: 'filled',
                    autoFooter: true,
                    destroy: true,
                    submitOnEnter: true,
                    tabindex: 90,
                    actions,
                    rows: [
                        [
                            {
                                name: 'vpw-old',
                                type: 'password',
                                label: this.$vuetify.lang.t('$vuetify.register.oldPw'),
                                hint: this.$vuetify.lang.t('$vuetify.register.oldPwHint'),
                                required: this.confirmOld,
                                hidden: !this.confirmOld,
                                autofocus: this.confirmOld
                            },
                            {
                                name: 'vpw-new',
                                type: 'password',
                                label: this.$vuetify.lang.t('$vuetify.register.newPw'),
                                experimental: false,
                                required: true,
                                autofocus: !this.confirmOld,
                                minlength: 8,
                                hint: this.$vuetify.lang.t('$vuetify.register.newPwHint'),
                                rules: [
                                    v => {
                                        // const hasInvalidChars = /[§°$´`+€%ß]/.test(v)
                                        const hasNumber = /[0-9]/.test(v)
                                        const hasUppercase = /[A-Z]/.test(v)
                                        return (hasNumber && hasUppercase) || this.$vuetify.lang.t('$vuetify.register.newPwInvalid')
                                    }
                                ]
                            },
                            {
                                name: 'vpw-new-confirm',
                                type: 'password',
                                label: this.$vuetify.lang.t('$vuetify.register.newPwConfirm'),
                                required: true,
                                minlength: 8,
                                hint: this.$vuetify.lang.t('$vuetify.register.newPwConfirmHint')
                            }
                        ]
                    ]
                }
            }
        },
        watch: {
            value() {
                this.dialog = this.value
            },
            dialog() {
                if (!this.dialog) this.close()
            }
        },

        mounted() {
            this.dialog = this.value
        },

        methods: {
            close() {
                const gf = this.$gridform[this.gfName]
                if (gf) gf.reset()
                this.$emit('cancel')
            }
        }
    }
</script>

<template>
    <VDialog v-model="dialog" max-width="720px" transition="scale-transition" :persistent="!cancel">
        <VSheet>
            <VGridform :name="gfName" :config="gfConfig" :callbacks="gfCallbacks"/>
        </VSheet>
    </VDialog>
</template>

<style>
    #vgf-gfPwDialog .v-messages {
        min-height: 28px;
    }
</style>
